
import React from 'react';
import { Edit2, Lock, Unlock, Trash2 } from 'lucide-react';
import '../../../../assets/css/components/serviceprovider/dashboard/paymentcar/PaymentCard.css';

const getBrand = (type = '') => {
  const t = type.toLowerCase();
  if (t.includes('visa')) return 'pc-card--visa';
  if (t.includes('master')) return 'pc-card--master';
  if (t.includes('american') || t.includes('amex')) return 'pc-card--amex';
  if (t.includes('union')) return 'pc-card--union';
  return 'pc-card--default';
};

const maskNumber = (number = '') => {
  const raw = number.replace(/\s/g, '');
  if (raw.length < 4) return number;
  return '**** **** **** ' + raw.slice(-4);
};

const PaymentCard = ({ card, onEdit, onToggleLock, onDelete }) => {
  return (
    <div className={`pc-card ${getBrand(card.type)} ${card.locked ? 'pc-card--locked' : ''}`}>

      {/* Top row: brand + lock toggle */}
      <div className="pc-card-top">
        <span className="pc-card-brand">{card.type.toUpperCase()}</span>
        <button
          className={`pc-lock-toggle ${card.locked ? 'pc-lock-toggle--on' : ''}`}
          onClick={() => onToggleLock(card.id)}
          aria-label={card.locked ? 'Unlock card' : 'Lock card'}
        >
          <span className="pc-lock-thumb">
            {card.locked ? <Lock size={11} /> : <Unlock size={11} />}
          </span>
        </button>
      </div>

      {/* Chip */}
      <div className="pc-card-chip" />

      {/* Masked number */}
      <p className="pc-card-number">{maskNumber(card.number)}</p>

      {/* Cardholder only — no expiry */}
      <div className="pc-card-row">
        <div className="pc-card-holder">
          <span className="pc-card-label">Cardholder</span>
          <span className="pc-card-value">{card.name}</span>
        </div>
      </div>

      {/* Actions — Edit + Delete only */}
      <div className="pc-card-actions">
        <button className="pc-action-btn" onClick={() => onEdit(card)}>
          <Edit2 size={13} /> Edit
        </button>
        <button className="pc-action-btn pc-action-btn--danger" onClick={() => onDelete(card.id)}>
          <Trash2 size={13} /> Delete
        </button>
      </div>

    </div>
  );
};

export default PaymentCard;